import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ClientOrganization } from '@origin8-web/models/core-business';
import { syncOrganizationParamToUrl } from './utils/organization-router.util';

@Injectable({ providedIn: 'root' })
export class OrganizationContextService {
  private readonly router = inject(Router);

  switchOrganization(organization: ClientOrganization): void {
    syncOrganizationParamToUrl(this.router, organization.name);
  }
}
